import EmojiPicker, { Theme } from "emoji-picker-react";
import { useTranslation } from "react-i18next";
import useThemeStore from "../store/useThemeStore";
import { getStoredLangCode } from "../utils/language";

const ThemedEmojiPicker = (props) => {
  const isDark = useThemeStore((state) => state.isDark);
  const { t } = useTranslation();
  const lang = getStoredLangCode();
  const isRtl = lang === "ar";

  const {
    width,
    height,
    searchPlaceHolder,
    previewConfig,
    ...rest
  } = props;

  return (
    <div
      className={`themed-emoji-picker-wrap${isRtl ? " themed-emoji-picker-rtl" : ""}`}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <style>{`
        .EmojiPickerReact .epr-search-container input {
          min-height: 35px !important;
          height: 35px !important;
          margin-bottom: 0 !important;
        }
        .EmojiPickerReact button {
          min-height: 0 !important;
          min-width: 0 !important;
        }
        .EmojiPickerReact .epr-category-nav > button {
          height: 30px !important;
          min-height: 30px !important;
          width: 30px !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        .EmojiPickerReact .epr-preview {
          height: auto !important;
          min-height: 50px !important;
        }
        .EmojiPickerReact .epr-preview img {
          max-height: 32px !important;
          max-width: 32px !important;
          object-fit: contain !important;
        }
      `}</style>
      <EmojiPicker
        {...rest}
        theme={isDark ? Theme.DARK : Theme.LIGHT}
        width={width ?? (isRtl ? 320 : 350)}
        height={height ?? 400}
        searchPlaceHolder={
          searchPlaceHolder ||
          t("SearchJob.Search", { defaultValue: "Search..." })
        }
        previewConfig={{
          showPreview: true,
          defaultCaption: t("Notifications.WhatsYourMood", {
            defaultValue: "What's your mood?",
          }),
          ...(previewConfig || {}),
        }}
      />
    </div>
  );
};

export default ThemedEmojiPicker;
